import React from 'react';

import { ImageSelectRender } from './ImageSelectRender';

export const ImageSelect = ({image,text}:any): JSX.Element => {
	return <ImageSelectRender image={image} text={text} />;
};
